import { defineComponent as _defineComponent } from 'vue'
import { useRouter } from '@nuxtjs/composition-api';
import CircularCloseButton from '~/components/UIComponents/CircularCloseButton.vue';
import { useStore } from '~/store/composable';
import { IMarketingBanner } from '~/types/sanity-documents';


export default /*#__PURE__*/_defineComponent({
  __name: 'ToolbarMarketingBanner',
  props: {
    banner: null
  },
  setup(__props: any) {

const props = __props as {
  banner: IMarketingBanner;
}



const { commit } = useStore();
const router = useRouter();

function redirectToCtaUrl() {
  close();
  if (props.banner.ctaUrl?.href) {
    router.push(props.banner.ctaUrl.href);
  }
}

function close() {
  commit('updateHasClosedToolbarMarketingBanner', true);
}

return { __sfc: true,props, commit, router, redirectToCtaUrl, close, CircularCloseButton }
}

})